import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-select-companies-modal',
  templateUrl: './select-companies-modal.component.html',
  styleUrls: ['./select-companies-modal.component.scss']
})
export class SelectCompaniesModalComponent implements OnInit {
  subject: Subject<boolean>;
  companyList: any[] = [];
  constructor(public bsModalRef: BsModalRef) { }

  ngOnInit(): void {
    this.companyList.push({name: 'Reliant Business Valuation'});
    this.companyList.push({name: 'Apple'});
    this.companyList.push({name: 'Google'});
    this.companyList.push({name: 'Codebridge'});
    this.companyList.push({name: 'IBM'});
    this.companyList.push({name: 'Reliant Business Valuation'});
    this.companyList.push({name: 'Apple'});
    this.companyList.push({name: 'Google'});
    this.companyList.push({name: 'Codebridge'});
    this.companyList.push({name: 'IBM'});
    this.companyList.push({name: 'Reliant Business Valuation'});
    this.companyList.push({name: 'Apple'});
    this.companyList.push({name: 'Google'});
    this.companyList.push({name: 'Codebridge'});
    this.companyList.push({name: 'IBM'});
    this.companyList.push({name: 'Reliant Business Valuation'});
    this.companyList.push({name: 'Apple'});
    this.companyList.push({name: 'Google'});
    this.companyList.push({name: 'Codebridge'});
    this.companyList.push({name: 'IBM'});
  }

  /**
   * @description confirm click
   */
  confirm(): void {
    this.bsModalRef.hide();
    this.subject.next(true);
    this.subject.complete();
  }
 
  /**
   * @description cancel click
   */
  decline(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

}
